<div class="table-scroll">
  <table mat-table [dataSource]="dataSource" matSort aria-label="Fish catches table">

    <ng-container matColumnDef="time">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Date / Time</th>
      <td mat-cell *matCellDef="let row">{{ row.time | date:'short' }}</td>
    </ng-container>

    <ng-container matColumnDef="fish_type">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Fish</th>
      <td mat-cell *matCellDef="let row">
        <span class="fish-type-dot" [style.background-color]="row.fish_type_display_color"></span>
        {{ row.fish_type_full_name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="tide">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Tide</th>
      <td mat-cell *matCellDef="let row">{{ row.tide_cycle ?? '—' }}</td>
    </ng-container>

    <ng-container matColumnDef="temperature">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Air °F</th>
      <td mat-cell *matCellDef="let row">{{ row.temperature !== null ? row.temperature : '—' }}</td>
    </ng-container>

    <ng-container matColumnDef="water_temperature">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Water °F</th>
      <td mat-cell *matCellDef="let row">{{ row.water_temperature !== null ? row.water_temperature : '—' }}</td>
    </ng-container>

    <ng-container matColumnDef="wind">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Wind</th>
      <td mat-cell *matCellDef="let row">
        {{ row.wind_speed ?? '—' }}{{ row.wind_speed && row.wind_direction ? ' ' + row.wind_direction : '' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="forecast">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Forecast</th>
      <td mat-cell *matCellDef="let row">{{ row.short_forecast ?? '—' }}</td>
    </ng-container>

    <ng-container matColumnDef="notes">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Notes</th>
      <td mat-cell *matCellDef="let row">
        <span class="notes-dot" *ngIf="row.has_user_notes" title="Has angler notes">●</span>
        <span *ngIf="!row.has_user_notes">—</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="analysis_generated_at">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Analysis</th>
      <td mat-cell *matCellDef="let row">
        {{ row.analysis_generated_at ? (row.analysis_generated_at | date:'M/d/yy HH:mm') : '—' }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"
        [routerLink]="row.catchId ? ['/catch', row.catchId] : null"
        [queryParams]="listParam ? { list: listParam } : null"
        class="clickable-row"></tr>
  </table>
</div>
